import React from "react";
import LegalDocument from "../components/LegalDocument";
import NavigationButtons from "../components/NavigationButtons";
import { useAuthState } from "../hooks/useAuth";
import { privacyDocument } from "../content/legalContent";

const Privacy = () => {
  const { user } = useAuthState();

  return (
    <>
      {user && <NavigationButtons />}
      <LegalDocument
        documentData={privacyDocument}
        className="legal-document--stacked"
      />
    </>
  );
};

export default Privacy;
